import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "has-submenu" }
const _hoisted_2 = { "aria-expanded": "false" }
const _hoisted_3 = ["aria-checked"]
const _hoisted_4 = {
  class: "switch-status",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_6 = ["aria-checked"]
const _hoisted_7 = {
  class: "switch-status",
  "aria-hidden": "true"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "/", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", {
  "aria-hidden": "true",
  class: "spacer"
}, null, -1)

import { computed, onMounted, ref } from 'vue';
    import { useStore } from 'vuex';

    import { useI18next } from '@composables/i18next';
    import { trackGdsEvent } from '@public/js/plugins/GdsPlugin';

    import MenuIcon from '@components/icons/MenuIcon.vue';
    import SocialShare from '@components/SocialShare.vue';


    // Setup
    
export default {
  __name: 'TheMenu',
  props: {
        isLight: {
            type: Boolean,
            default: false,
        },
    },
  setup(__props) {

    

    const store = useStore();
    const { t, vT } = useI18next(['global', 'links']);


    // Data
    const root = ref();

    let mouseoverTimeout;


    // Computed
    const animationEnabled = computed(() => store.getters['ui/isAnimationEnabled']);

    const soundEnabled = computed(() => store.getters['ui/isSoundEnabled']);


    // Methods
    function toggleAnimation () {
        const currentValue = animationEnabled.value;
        store.commit('ui/setAnimationEnabled', {
            animationEnabled: !currentValue,
            name: store.state.app.name,
        });
        trackGdsMenu();
    }

    function toggleSound () {
        const currentValue = soundEnabled.value;
        store.commit('ui/setSoundEnabled', {
            soundEnabled: !currentValue,
            name: store.state.app.name,
        });
        trackGdsMenu();
    }

    // Methods
    function trackGdsMenu () {
        const dimensions = {};
        trackGdsEvent({
            category: t('gdsText:templateNames.menu'),
            action: t('gdsText:screenDetails.menu'),
            dimensions,
        });
    }

    // Lifecycle
    onMounted(() => {
        const menuItems = root.value.querySelectorAll('li.has-submenu');
        for (const item of menuItems) {
            // Allow keyboard users to activate submenu
            item.querySelector('a, button').addEventListener('click', function (event) {
                if (this.parentNode.classList.contains('open')) {
                    this.parentNode.classList.remove('open');
                    this.setAttribute('aria-expanded', 'false');
                }
                else {
                    this.parentNode.classList.add('open');
                    this.setAttribute('aria-expanded', 'true');
                }

                event.preventDefault();
                return false;
            });

            // Close submenu if user tabs past last item
            // Use keydown because that means they were already on the item when they pressed Tab
            item.querySelector('ul li:last-of-type').addEventListener('keydown', function (event) {
                this.closest('li.has-submenu.open')?.classList.remove('open');
            });
        }
    });

return (_ctx, _cache) => {
  const _component_RouterLink = _resolveComponent("RouterLink")

  return (_openBlock(), _createElementBlock("nav", {
    ref_key: "root",
    ref: root,
    class: _normalizeClass(["the-menu", { light: __props.isLight }])
  }, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createVNode(MenuIcon),
          _withDirectives(_createElementVNode("span", null, null, 512), [
            [_unref(vT), 'links:menu']
          ])
        ]),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              role: "switch",
              "aria-checked": animationEnabled.value,
              onClick: _withModifiers(toggleAnimation, ["stop"])
            }, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_unref(vT), 'links:animation']
              ]),
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass({ active: animationEnabled.value })
                }, null, 2), [
                  [_unref(vT), 'links:animation_options.yes']
                ]),
                _hoisted_5,
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass({ active: !animationEnabled.value })
                }, null, 2), [
                  [_unref(vT), 'links:animation_options.no']
                ])
              ])
            ], 8, _hoisted_3)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              role: "switch",
              "aria-checked": soundEnabled.value,
              onClick: _withModifiers(toggleSound, ["stop"])
            }, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_unref(vT), 'links:sound']
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass({ active: soundEnabled.value })
                }, null, 2), [
                  [_unref(vT), 'links:sound_options.yes']
                ]),
                _hoisted_8,
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass({ active: !soundEnabled.value })
                }, null, 2), [
                  [_unref(vT), 'links:sound_options.no']
                ])
              ])
            ], 8, _hoisted_6)
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_RouterLink, { to: "/welcome" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("span", null, null, 512), [
                  [_unref(vT), 'links:view_instructions']
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_9,
      _createElementVNode("li", null, [
        _createVNode(SocialShare, { "is-light": __props.isLight }, null, 8, ["is-light"])
      ])
    ])
  ], 2))
}
}

}